var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("申请详情")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("基本信息")]),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              attrs: { model: _vm.infoForm, "label-width": "130px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户姓名" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: { placeholder: "请输入用户姓名", disabled: "" },
                    model: {
                      value: _vm.infoForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "name", $$v)
                      },
                      expression: "infoForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: {
                      placeholder: "请输入联系电话",
                      disabled: "",
                      oninput:
                        "\n            value = value.replace(/[^\\d]/g, '');\n            if (value.length > 11) value = value.slice(0, 11);\n          ",
                    },
                    model: {
                      value: _vm.infoForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "phone", $$v)
                      },
                      expression: "infoForm.phone",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item"),
              _c(
                "el-form-item",
                { attrs: { label: "店铺类型" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: { placeholder: "请输入店铺类型", disabled: "" },
                    model: {
                      value: _vm.infoForm.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "type", $$v)
                      },
                      expression: "infoForm.type",
                    },
                  }),
                ],
                1
              ),
              _c("h3", [_vm._v("申请资料")]),
              _c(
                "el-form-item",
                { attrs: { label: "小程序名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: { placeholder: "请输入小程序名称", disabled: "" },
                    model: {
                      value: _vm.infoForm.miniAppName,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "miniAppName", $$v)
                      },
                      expression: "infoForm.miniAppName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "小程序说明" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入小程序说明",
                      maxlength: "120",
                      "show-word-limit": "",
                      disabled: "",
                      rows: 5,
                    },
                    model: {
                      value: _vm.infoForm.miniAppInfo,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "miniAppInfo", $$v)
                      },
                      expression: "infoForm.miniAppInfo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "小程序头像" } },
                [
                  _c("el-image", {
                    staticStyle: { width: "120px", height: "120px" },
                    attrs: { src: _vm.infoForm.miniAppTopImg },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.miniAppTopImg)
                      },
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "小程序管理员电话" } }, [
                _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: { width: "30%" },
                      attrs: {
                        disabled: "",
                        placeholder: "请输入电话",
                        oninput:
                          "\n            value = value.replace(/[^\\d]/g, '');\n            if (value.length > 11) value = value.slice(0, 11);\n          ",
                      },
                      model: {
                        value: _vm.infoForm.miniAppManagerPhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "miniAppManagerPhone", $$v)
                        },
                        expression: "infoForm.miniAppManagerPhone",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "管理员身份证正面" } },
                [
                  _c("el-image", {
                    staticStyle: { width: "300px", height: "150px" },
                    attrs: { src: _vm.infoForm.managerIdentifyTop },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.managerIdentifyTop)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "管理员身份证反面", prop: "name" } },
                [
                  _c("el-image", {
                    staticStyle: { width: "300px", height: "150px" },
                    attrs: { src: _vm.infoForm.managerIdentifyBottom },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.managerIdentifyBottom)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "营业执照", prop: "name" } },
                [
                  _c("el-image", {
                    staticStyle: { width: "300px", height: "150px" },
                    attrs: { src: _vm.infoForm.license },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.license)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                width: "10%",
                "text-align": "center",
                "padding-bottom": "20px",
              },
            },
            [_c("el-button", { on: { click: _vm.back } }, [_vm._v("返回")])],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("申请详情")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }